import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { Route } from 'react-router-dom';
import { TestDashboard } from './testDashboard/TestDashboard';

const acRoutes = [
  <Route path="/ac/rqmt" element={<EntityView />} />,
  <Route path="/ac/suite" element={<EntityView />} />,
  <Route path="/ac/test" element={<EntityView />} />,
  <Route path="/ac/dashboard/test" element={<TestDashboard />} />,
];

export default acRoutes;
